import Modal from '../../../../components/Modal'
import Badge from '../../../../components/Badge'
import { memo, useContext, useState } from 'react'
import ReasonCardInput from '../../ReasonCardInput'
import { DataStore } from '@aws-amplify/datastore'
import { DgtPdOrderReasonCode } from '../../../../models'
import OrderContext from '../../../../contexts/OrderContext'
import UserContext from '../../../../contexts/UserContext'
import { ImCancelCircle } from 'react-icons/im'
import { OrderStatusCode, OrderStatusTheme, OrderReasonCodeStatusDisplay } from '../../../../constants/Enum'
import { convertJson } from '../../../../utilities/Validate'

const ReasonCodeDraft = ({ reasonCodes, pleaseRefresh }) => {
  const matCodeDefault = reasonCodes[0].materialCode

  const [currentMatCode, setCurrentMatCode] = useState(matCodeDefault)
  const [modalShow, setModalShow] = useState(false)
  const [unsaveWarningShow, setUnsaveWarningShow] = useState(false)
  const [quantities, setQuantities] = useState([])
  const [tempMatCode, setTempMatCode] = useState('')

  const { order } = useContext(OrderContext)
  const { readOnly } = useContext(UserContext)

  const onQuantityChanged = async (reasonCode, quantity, description) => {
    let newQuantities = []
    if (quantities.length === 0) {
      const selectedMaterial = findMaterial(reasonCodes, currentMatCode)
      const listOfReason = convertJson(selectedMaterial.reasonCodes)
      newQuantities = [...listOfReason]
    } else {
      newQuantities = [...quantities]
    }

    const idx = newQuantities.findIndex(rc => rc.reasonCode === reasonCode)
    if (idx >= 0) { // defined reason
      let updatedQty = {...newQuantities[idx]}
      updatedQty.quantity = quantity
      updatedQty.reasonDescription = description
      newQuantities[idx] = updatedQty
    } else { // other reason
      newQuantities.push({
        quantity: quantity,
        reasonCode: 'R9',
        reasonDescription: description
      })
    }

    setQuantities(newQuantities)
  }

  const onTabSelected = (key) => {
    if (quantities.length > 0 && quantities.reduce(concatQtyFunc, '') !== listOfReason.reduce(concatQtyFunc, '')) {
      setTempMatCode(key)
      setUnsaveWarningShow(true)
    } else {
      setQuantities([])
      setCurrentMatCode(key)
    }
  }

  const onCancelSave = () => {
    setQuantities([])
    setTempMatCode('')
    setUnsaveWarningShow(false)
  }

  const onConfirmSave = async () => {
    await onSubmit()
    setCurrentMatCode(tempMatCode)
    setTempMatCode('')
    setUnsaveWarningShow(false)
  }

  const onSubmit = async () => {
    try {
      setModalShow(false)

      const selectedMaterial = findMaterial(reasonCodes, currentMatCode)
      const original = await DataStore.query(DgtPdOrderReasonCode, selectedMaterial.id)
      if (original) {
        await DataStore.save(DgtPdOrderReasonCode.copyOf(original, updated => {
          updated.reasonCodes = JSON.stringify(quantities)
          updated.confirmStatus = OrderStatusCode.DRAFTED
        }))
      }

      setQuantities([])
      pleaseRefresh()
    } catch (error) {
      console.log(error)
    }
  }

  const selectedMaterial = findMaterial(reasonCodes, currentMatCode)

  let listOfReason = convertJson(selectedMaterial.reasonCodes)
    .map(rc => { return { ...rc, quantity: rc.quantity ? rc.quantity : '' } })
    .sort((a, b) => (a.reasonCode.localeCompare(b.reasonCode)))

  const renderBtn = () => {
    if (quantities.length > 0 && quantities.reduce(concatQtyFunc, '') !== listOfReason.reduce(concatQtyFunc, '')) {
      return <button className='text-sm btn-success' onClick={() => setModalShow(true)}>บันทึก</button>
    } else {
      return <button className='btn-outline-success' disabled>บันทึก</button>
    }
  }
  const sumOfDefectQty = sumDefectQty(quantities)

  return <div>
    <div className='flex flex-col mt-2 mb-1 md:flex-row gap-7 '>
      <div className='lg:basis-1/4'>
        <h6>รายการ Material</h6>
        <div className="list-group">
          {reasonCodes.map(mat =>
            <button key={mat.materialCode}
              className={`px-2 py-3 text-left first:rounded-t last:rounded-b border${currentMatCode === mat.materialCode ? ' bg-blue-100 border-blue-600':''}`}
              onClick={() => onTabSelected(mat.materialCode)}>
              <div className="flex flex-col break-words">
                <h6 className={`${OrderReasonCodeStatusDisplay[mat.confirmStatus] ? '': 'hidden'}`}><Badge variant={OrderStatusTheme[mat.confirmStatus]}>{OrderReasonCodeStatusDisplay[mat.confirmStatus]}</Badge></h6>
                <h6 className={`${currentMatCode === mat.materialCode ? 'text-blue-600':'text-gray-500'}`}>{mat.materialDescription}</h6>
                <h6 className='text-sm font-light'>{mat.materialCode}</h6>
              </div>
            </button>
          )}
        </div>
      </div>
      <div className='lg:basis-3/4'>
        <div className='flex justify-between'>
          <div>
            <h6 className='text-xs text-muted'>Material</h6>
            <h6>{selectedMaterial.materialCode}</h6>
          </div>
          <div>
            <h6 className='text-xs text-muted'>Lab/Office</h6>
            <h6>{selectedMaterial.labOffice}</h6>
          </div>
          <div>
            <div className="flex items-end justify-end mb-2">
              {renderBtn()}
            </div>
          </div>
        </div>
        <div className='grid grid-cols-1 pb-5 mt-3 md:grid-cols-2 lg:grid-cols-3 gap-7'>
          {listOfReason.map(code =>
            <div key={`${code.reasonCode}${code.reasonDescription}`}>
              <ReasonCardInput code={{
                ...code, unit: selectedMaterial.unit
              }}
                defaultValue={code.quantity} onQuantityChanged={onQuantityChanged} disabled={selectedMaterial.confirmStatus === OrderStatusCode.CONFIRMED || readOnly}/>
            </div>
          )}
        </div>
      </div>
    </div>
    <Modal
      show={modalShow}
      title={`คุณกำลังจะบันทึกข้อมูล Reason Code ของ ${currentMatCode}`}
      cancelText={sumOfDefectQty > order.orderQty ? 'กลับไปแก้ไข' : 'ยกเลิก'}
      okText={sumOfDefectQty > order.orderQty ? null : 'ยืนยัน'}
      okTheme='success'
      okAction={onSubmit}
      onHide={() => setModalShow(false)}
    >
      <div className={`${sumOfDefectQty > order.orderQty ? '': 'hidden'}`}>
        <h1 className="mb-3 text-center w-100"><ImCancelCircle color="red" /></h1>
        <h4 className="text-center w-100">ไม่สามารถบันทึกจำนวนของเสียรวม เกินจำนวนยอด Order ได้</h4>
      </div>
      <div className={`${sumOfDefectQty > order.orderQty ? 'hidden': ''} mt-3`}>
        <h5 className='mb-3'>รายการที่กำลังจะถูกบันทึก</h5>
        {quantities.filter(rc => parseFloat(rc.quantity) > 0)
          .sort((a, b) => a.reasonCode.localeCompare(b.reasonCode)).map(rc =>
            <div className='flex justify-between' key={rc.reasonCode}>
              <h6 className=' basis-2/3'>
                {rc.reasonCode} - {rc.reasonDescription}
              </h6>
              <div className='flex justify-between basis-1/3'>
                <h6>จำนวน</h6>
                <h6>{rc.quantity}</h6>
                <h6>{selectedMaterial.unit}</h6>
              </div>
            </div>
          )}
      </div>
    </Modal>
    <Modal show={unsaveWarningShow} onHide={() => setUnsaveWarningShow(false)}
      title='มีการแก้ไขข้อมูล'
      body='คุณยังไม่ได้บันทึกข้อมูลที่แก้ไข คุณต้องการบันทึกใช่หรือไม่ ?'
      okTheme='success'
      okText='บันทึก'
      okAction={onConfirmSave}
      cancelText='ยกเลิก'
      cancelAction={onCancelSave}>
    </Modal>
  </div>
}

const findMaterial = (reasonCodes, currentMatCode) => {
  return reasonCodes.find(m => m.materialCode === currentMatCode)
}

const sumDefectQty = (array) => {
  return array.reduce((prev, cur) => prev + (cur.quantity ? parseInt(cur.quantity) : 0), 0)
}

const concatQtyFunc = (prev, cur) => prev + cur.quantity

export default memo(ReasonCodeDraft)